import clsx from "clsx";

import { AlertSuccess24 } from "@hagerty/icons";

import { Bill } from "../bill/Bill";
import { Card } from "../../../Card";
import { ApexApiBill, ApexBill } from "../apexBill";
import { ApiBill } from "../bill/Bill.types";

import styles from "./Bills.module.scss";
import { BillsProps } from "./Bills.types";

export const Bills = ({
  isLoading,
  bills,
  apexBillPhoneNumber,
  className,
  style,
  returnUrl,
  returnButtonLabel,
  onPayBillClick,
  onViewBillDetailsClick,
  onBillAction,
}: BillsProps) => (
  <div
    className={clsx(styles.wrapper, className)}
    style={style}
    {...(isLoading
      ? { "aria-valuetext": "Loading'...", tabIndex: 0, role: "progressbar" }
      : {})}
  >
    {isLoading && (
      <>
        <Bill.Skeleton />
        <Bill.Skeleton />
      </>
    )}
    {!isLoading && bills && bills?.length === 0 && (
      <Card className={styles.noBillsCard}>
        <AlertSuccess24 />
        <div>
          {/* @TODO: Add "view history" when history is ready */}
          <p className={styles.noBillsTitle}>All caught up!</p>
          <p>No bills due at this time.</p>
        </div>
      </Card>
    )}
    {!isLoading &&
      bills &&
      bills.map((bill) =>
        (bill as ApexApiBill).source === "apex" ? (
          <ApexBill
            key={(bill as ApexApiBill).policyNumber}
            bill={bill as ApexApiBill}
            phoneNumber={apexBillPhoneNumber}
          />
        ) : (
          <Bill
            key={(bill as ApiBill).id}
            bill={bill as ApiBill}
            returnUrl={returnUrl}
            returnButtonLabel={returnButtonLabel}
            onPayClick={onPayBillClick}
            onViewDetailsClick={onViewBillDetailsClick}
            onAction={onBillAction}
          />
        )
      )}
  </div>
);
